module.exports = __webpack_public_path__ + "static/img/200194.1fb7370a.png";